/**
 * Our Network Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initOurNetwork() {
    const blocks = document.querySelectorAll(".contact-with-map");

    blocks.forEach((block) => {
      const imageSide = block.querySelector(".image_side");
      const mapPoints = block.querySelectorAll(".map-point");

      if (imageSide && mapPoints.length > 0) {
        // Wait for GSAP to be available
        let retryCount = 0;
        const maxRetries = 50;

        function checkGSAP() {
          retryCount++;

          let gsapLib = null;
          let ScrollTriggerLib = null;

          if (typeof gsap !== "undefined") {
            gsapLib = gsap;
          } else if (typeof window.gsap !== "undefined") {
            gsapLib = window.gsap;
          } else if (
            window.SOJ_GSAP_ANIMATIONS &&
            window.SOJ_GSAP_ANIMATIONS.gsap
          ) {
            gsapLib = window.SOJ_GSAP_ANIMATIONS.gsap;
          }

          if (typeof ScrollTrigger !== "undefined") {
            ScrollTriggerLib = ScrollTrigger;
          } else if (typeof window.ScrollTrigger !== "undefined") {
            ScrollTriggerLib = window.ScrollTrigger;
          }

          if (gsapLib && ScrollTriggerLib) {
            // Register ScrollTrigger plugin if needed
            if (!gsapLib.plugins || !gsapLib.plugins.scrollTrigger) {
              gsapLib.registerPlugin(ScrollTriggerLib);
            }

            // Get all dot elements
            const dots = Array.from(mapPoints).map((point) =>
              point.querySelector(".dot")
            );

            // Set initial state
            gsapLib.set(dots, {
              opacity: 0,
              scale: 0,
            });

            // Create stagger animation with ScrollTrigger
            gsapLib.to(dots, {
              opacity: 1,
              scale: 1,
              duration: 0.6,
              ease: "back.out(1.7)",
              delay: 0.1, // 1 second delay before animation starts
              scrollTrigger: {
                trigger: imageSide,
                start: "top 80%",
                toggleActions: "play none none none",
                once: true,
              },
              onComplete: function () {
                // Add pulse animation class after stagger completes with random delay
                dots.forEach((dot) => {
                  if (dot) {
                    // Generate random delay between 0 and 2 seconds
                    const randomDelay = Math.random() * 1;
                    dot.style.animationDelay = randomDelay + "s";
                    dot.classList.add("animated");
                  }
                });
              },
            });

            console.log(
              "[BLOCK] contact-with-map block initialized with stagger animation"
            );
            return;
          }

          if (retryCount < maxRetries) {
            setTimeout(checkGSAP, 100);
          } else {
            console.log(
              "[BLOCK] contact-with-map block initialized (GSAP not available)"
            );
          }
        }

        checkGSAP();
      } else {
        console.log("[BLOCK] contact-with-map block initialized");
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOurNetwork);
  } else {
    initOurNetwork();
  }
})();
